<template>
  <div :class="vInputPasswordClassName">

    <slot name="above-input-password"></slot>

    <!-- Your should use <template v-slot:default="{ type }"></template> to get props in slot -->
    <slot :type="isType"></slot>

    <span @click="onVisible">
        <svg v-if="isType === 'password'" class="v-input-password__visible" width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.257 6.962C20.731 7.582 20.731 8.419 20.257 9.038C18.764 10.987 15.182 15 11 15C6.81801 15 3.23601 10.987 1.74301 9.038C1.51239 8.74113 1.38721 8.37592 1.38721 8C1.38721 7.62408 1.51239 7.25887 1.74301 6.962C3.23601 5.013 6.81801 1 11 1C15.182 1 18.764 5.013 20.257 6.962V6.962Z" stroke="#6E6B7B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 11C12.6569 11 14 9.65685 14 8C14 6.34315 12.6569 5 11 5C9.34315 5 8 6.34315 8 8C8 9.65685 9.34315 11 11 11Z" stroke="#6E6B7B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <svg v-else class="v-input-password__visible" xmlns="http://www.w3.org/2000/svg" width="22px" height="20px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
    </span>
  </div>
</template>

<script>
export default {
    name: "v-input-password",
    props: {
        hasLabel: Boolean,
    },
    data() {
        return {
            isVisible: false
        }
    },
    computed: {
        vInputPasswordClassName() {
            return {
                "v-input-password": true,
                "v-input-password--hasLabel": this.hasLabel,
                "relative": true,
                // "v-input-password--visible": this.isVisible 
            }
        },
        isType() {
            return this.isVisible ? "text" : "password"
        }
    },
    methods: {
        onVisible() {
            this.isVisible = !this.isVisible;

            this.$emit("visible", this.isVisible);
        }
    },
}
</script>

<style lang="scss" scope>

.v-input-password {
    &__visible {
        position: absolute;
        top: 20px;
        right: 15px;
        transform: translateY(-50%);
        cursor: pointer;
        transition: all 300ms ease;

        path, line {
            stroke: #BABFC7;
        }
    }

    &.v-input-password--hasLabel {
        .v-input-password__visible {
            top: 40px;
        }
    }

    // &.v-input-password--visible {
    //     .v-input-password__visible {
    //     }
    // }
}

// Custom validation
// .v-input-password {
//     .input-icon-validate-danger + span .v-input-password__visible,
//     .input-icon-validate-success + span .v-input-password__visible,
//     .input-icon-validate-warning + span .v-input-password__visible {
//         position: absolute;
//         top: 32%;
//         right: 15px;
//         transform: translateY(-50%);
//         cursor: pointer;

//         path, line {
//             stroke: #BABFC7;
//         }
//     }
// }
</style>


// WEBPACK FOOTER //
// src/components/Input/VInputPassword.vue